import React, { Component } from 'react';
import { connect } from 'react-redux';
import GlobalLoader from '../components/Loader';

export class GlobalLoaderContainer extends Component {
  render() {
    const { isLoading } = this.props;

    if (!isLoading) {
      return null;
    }
    return <GlobalLoader {...this.props} />;
  }
}

const mapStateToProps = ({ loader }) => ({
  isLoading: loader.isLoading,
});

export default connect(mapStateToProps, null)(GlobalLoaderContainer);
